<h1>Add Sub Category <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="row">
    <div class="col-sm-12">
        <form [formGroup]="subCategoryModalForm" (submit)="submitSubCategory()">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 mt-5">
                        <label class="form-label">Lab Test Category *</label>
                        <mat-select placeholder="Select Test Category" formControlName="lab_test_category">
                            <mat-option>Select Test</mat-option>
                            <mat-option [value]="test.id" *ngFor="let test of labTest">{{test.name}}
                            </mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.lab_test_category.errors" class="invalid-feedback">
                            <div *ngIf="f.lab_test_category.errors.required">Lab test catergory is required</div>
                        </div>
                    </div>
                    <div class="col-md-6 mt-5">
                        <label class="form-label">Lab Test Sub Category *</label>
                        <input type="text" formControlName="lab_test_subcategory" class="form-control"/>
                        <div *ngIf="submitted && f.lab_test_subcategory.errors" class="invalid-feedback">
                            <div *ngIf="f.lab_test_subcategory.errors.required">Lab Test Sub Category is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>
</div>
